import React, { forwardRef } from 'react';

/**
 * Thin progress / meter bar (credits, char count, upload).
 *
 * Fill width and aria-valuenow are always whole percentages (0–100).
 *
 * @param {object} props
 * @param {number} props.value — 0–100 (floats are rounded)
 * @param {string} [props.barClassName='bg-gradient-insight'] — fill classes
 * @param {string} [props.trackClassName]
 * @param {string} [props.className]
 * @param {string} [props['aria-label']]
 */
const Progress = forwardRef(function Progress(
  {
    value = 0,
    barClassName = 'bg-gradient-insight',
    trackClassName = 'bg-white/10',
    className = '',
    'aria-label': ariaLabel = 'Progress',
    ...rest
  },
  ref
) {
  // Whole-number fill only — callers may pass floats from progress math.
  const clamped = Math.round(Math.max(0, Math.min(100, Number(value) || 0)));
  return (
    <div
      ref={ref}
      className={`h-1.5 w-full rounded-full overflow-hidden ${trackClassName} ${className}`.trim()}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={clamped}
      aria-label={ariaLabel}
      {...rest}
    >
      <div
        className={`h-full rounded-full transition-[width] duration-500 ease-out ${barClassName}`}
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
});

export default Progress;
